import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchReports } from 'ducks/reports';
import { CaseOverviewTable } from 'components/Tables';

class CaseOverview extends Component {
  static propTypes = {
    router: PropTypes.any,
    reports: PropTypes.any,
    dispatch: PropTypes.func
  };

  componentDidMount = () => this.getReports();

  getReports = () => {
    let {
      router: {
        params: { program, project }
      },
      dispatch
    } = this.props;
    dispatch(fetchReports({ reportType: 'case_overview', program, project }));
  };

  render() {
    let { router, reports } = this.props;

    return (
      <div style={{ width: `100%` }}>
        { reports &&
        <CaseOverviewTable router={ router }>
          { reports }
        </CaseOverviewTable>
        }
      </div>
    );
  }
}

export default connect(
  ({ router, reports }) => ({ router, reports })
)(CaseOverview);
